import { createI18n } from "vue-i18n";
import { languageEnum } from "@/enums/plugins/i18n"
import objectData from "./object-data";

// TO-DO lazy-loading 
const messages = {
    en: {
        COMMON: {
            TUTOTIAL: "Tutorial",
            VERSION: "Version",
            PRICE: "Price",
            DATE: "Date",
            LEVEL: "Level",
            lEVEL_FOUNDATIONALl: "Foundational",
            lEVEL_MEDIUM: "Medium",
            lEVEL_ADVANCED: "Advanced",
            SORT_LATEST: "Latest",
            SORT_OLDEST: "Oldest",
            SORT_RELEVANCE: "Relevance",
            HOSTED: "Hosted",
            LIVE_DEMO_OUTLINE : "Live Demo Outline",
            UPDATE_BOOKMARK_STATUS_SUCCESS: "Successfully bookmarked",
            UPDATE_CANCEL_BOOKMARK_STATUS_SUCCESS: "Removed from your bookmark",
            API_ERROR_TITLE: `<div class="api-error-message-title">Error!</div>`,
            API_ERROR_DESCRIPTION: `<div class="api-error-message-content">Please wait a few minutes before you try again.</div>`,
            NEW: "NEW",
            NO_SEARCH_RESULTS_FOUND: "No search results found.",
            REALLUSION_COURSES: "Reallusion Courses",
            SKILL_PATH: 'Skill Paths'
        },
        PAGE_BOOKMARK: {
            BOOKMARK: "Bookmark",
            NO_VIDEO: "No bookmarked videos yet",
            FILTER_ALL: "All",
        },
        TOP_NAV: {
            LOG_IN: "Log In",
            SIGN_UP: "Sign Up",
            LOG_OUT: "Logout",
            BOOKMARK: "Bookmark",
            HISTORY: "History"
        },
        HOME: {
            NAME: "Home",
            SEARCH_TITLE: "REALLUSION COURSES",
            SEARCH_DESC: "A free learning platform that offers stepwise video courses and hands-on webinars.",
            SEARCH_PLACEHOLDER: "Search free online tutorials",
            GROUP_TITLE: "CHOOSE A PRODUCT TO LEARN",
            TEXT_BANNER: {
                TITLE: "Save <span style=\"color: #ff5722\">60%</span> on Reallusion Creative Software - For Students and Teachers",
                URL: "https://www.reallusion.com/global-training/educational-licensing.html#for-students-and-teachers-disable-scroll"
            },
            BANNER_TITLE: "EXPLORE RECOMMENDED COURSES",
            TITLE_SUPPORT: "COMMUNITY & SUPPORT",
            MAGAZINE: "Magazine",
            MAGAZINE_LINK: "https://magazine.reallusion.com/",
            MAGAZINE_DESC: "Get the latest Reallusion news, learn from our power users, and find the best showcases.",
            FORUM: "Forum",
            FORUM_LINK: "https://discussions.reallusion.com/",
            FORUM_DESC: "Learn from experienced users, share your creations, and comment on ideas.",
            DEVELOPER_CENTER: "Developer Center",
            DEVELOPER_CENTER_LINK: "https://developer.reallusion.com/default.html",
            DEVELOPER_CENTER_DESC: "Join Reallusion and become a certified developer to create digital content or plug-ins.",
            FAQ: "FAQ",
            FAQ_LINK: "https://kb.reallusion.com/Default.aspx?lang=1",
            FAQ_DESC: "Get quick answers to common questions about installation, membership and purchases.",
            CUSTOMER_SERVICE: "Customer Service",
            CUSTOMER_SERVICE_LINK: "https://www.reallusion.com/CustomerSupport/UserEx/QForm.html",
            CUSTOMER_SERVICE_DESC: "For any problem-solving issues, log into your member account to submit a support ticket.",
            FEEDBACK_TRACKER: "Feedback Tracker",
            FEEDBACK_TRACKER_LINK: "https://www.reallusion.com/FeedBackTracker/",
            FEEDBACK_TRACKER_DESC: "Participate in our product improvement and development cycles by sharing your suggestions.",
            META: {
                TITLE: "Reallusion Courses - Free Online Tutorials for 2D & 3D Animations",
                DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
                OG_TITLE: "Reallusion Courses - Free Online Tutorials for 2D & 3D Animations",
                OG_DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
            }
        },
        HOME_EXPLORER: {
            META: {
                ICLONE: {
                    TITLE: "iClone Tutorials - Reallusion Courses",
                    DESCRIPTION: "Level up your skills by learning character animation, including animation and mocap editing for iClone.",
                    OG_TITLE: "iClone Tutorials - Reallusion Courses",
                    OG_DESCRIPTION: "Level up your skills by learning character animation, including animation and mocap editing for iClone.",
                },
                CHARACTER_CREATOR: {
                    TITLE: "Character Creator Tutorials - Reallusion Courses",
                    DESCRIPTION: "Learn the complete character creation solution that connects the industry-leading pipelines with one system for 3D character generation and animation rigging in Character Creator.",
                    OG_TITLE: "Character Creator Tutorials - Reallusion Courses",
                    OG_DESCRIPTION: "Learn the complete character creation solution that connects the industry-leading pipelines with one system for 3D character generation and animation rigging in Character Creator.",
                },
                CARTOON_ANIMATOR: {
                    TITLE: "Cartoon Animator Tutorials - Reallusion Courses",
                    DESCRIPTION: "Learn Cartoon Animator, the 2D animation software designed for ease of entry, productivity, and comprehensive pipelines.",
                    OG_TITLE: "Cartoon Animator Tutorials - Reallusion Courses",
                    OG_DESCRIPTION: "Learn Cartoon Animator, the 2D animation software designed for ease of entry, productivity, and comprehensive pipelines.",
                },
                ACTORCORE: {
                    TITLE: "ActorCore Tutorials - Reallusion Courses",
                    DESCRIPTION: "Learn how to use ActorCore, the one-stop platform for 3D motions, characters and rigging on a premium level.",
                    OG_TITLE: "ActorCore Tutorials - Reallusion Courses",
                    OG_DESCRIPTION: "Learn how to use ActorCore, the one-stop platform for 3D motions, characters and rigging on a premium level.",
                },
                SMART_GALLERY: {
                    TITLE: "Smart Content Manager Tutorials - Reallusion Courses",
                    DESCRIPTION: "Instructions on utilizing the Smart Content Manager and managing your assets across Reallusion products.",
                    OG_TITLE: "Smart Content Manager Tutorials - Reallusion Courses",
                    OG_DESCRIPTION: "Instructions on utilizing the Smart Content Manager and managing your assets across Reallusion products.",
                },
            }
        },
        VIDEO_DETAIL: {
            TITLE_DESCRIPTION: "Description & Reference",
            TITLE_RELEVANCE: "Relevance",
            SPEAKERS: "Hosted by",
            TUTORIAL: "Tutorial",
            FREE: "Free",
            RESOURCE: "Resource",
            ONLINE_MANUAL: "Online Manual",
            TUTORIAL_ARTICLES: "Tutorial Articles",
            DOWNLOAD_FILES: "Download Files",
            INSTRUCTOR: "Instructor"
        },
        LIBRARY: {
            FILTER_PRODUCT: "All Product",
            FILTER_VERSION: "All Version",
            FILTER_LEVEL: "All Level",
            CLEAN_FILTER: "CLEAN FILTER",
            RESULTS: "Results",
            FILTER_TITLE: "SORTING & FILTER",
            FILTER: "FILTER",
            SORTING: "SORTING",
            SORTING_BY: "Sort by",
            SEARCH_PLACEHOLDER: "Search",
            META: {
                TITLE: "Search for Tutorials - Reallusion Courses",
                DESCRIPTION: "Search specific topics for 2D or 3D animation tutorials for iClone, Character Creator and Cartoon Animator in Reallusion Courses.",
                OG_TITLE: "Search for Tutorials - Reallusion Courses",
                OG_DESCRIPTION: "Search specific topics for 2D or 3D animation tutorials for iClone, Character Creator and Cartoon Animator in Reallusion Courses.",
            },
        },
        WEBINAR: {
            NAME: "Webinar",
            UPCOMING: {
                NAME: "Upcoming",
                DESCRIPTION_TITLE: "Live Webinar: Connect & Interact with Professionals",
                DESCRIPTION_CONTENT: "Now is your chance to meet our professional trainers, get your questions answered, and observe their workflow live in a real-time interactive environment!  This is a learning channel that will keep you updated on the latest news and give you the chance to get guidance on your own projects as well.",
                NOTE: "Note: If you can't attend the live webinar, register anyway and we'll send you a link to watch the replay.",
                CHECK_YOUR_LOCAL_TIME: "Check your local time",
                SEE_MORE :"See More",
                GET_IT_NOW :"Get it Now",
                REGISTER_NOW: "Register Now",
                NEXT_WEBINAR_IS_COMING_SOON: "Next webinar is coming soon. To be announced.",
                TESTIMONIAL: "Testimonial",
            },
            ARCHIVE: "Archive",
            SPEAKER_INTRODUCTION: "Speaker Introduction",
            META: {
                TITLE: "Webinar - Reallusion Courses",
                DESCRIPTION: "Watch Reallusion live webinar to learn tips or connect and interact with our professional instructors. ",
                OG_TITLE: "Webinar - Reallusion Courses",
                OG_DESCRIPTION: "Watch Reallusion live webinar to learn tips or connect and interact with our professional instructors. ",
            },
        },
        HISTORY: {
            CLEAN_ALL_HISTORY: "CLEAN ALL WATCH HISTORY",
            FILTER_TYPE: "All Type",
            REMOVE_FROM_WATCH_HISTORY: "Remove from watch history",
            REMOVE_ALL_HISTORY: "All views of this video removed from history",
            REMOVE_VIDEO_HISTORY: "This video is removed from history",
            REMOVE_HISTORY_ERROR: "Failed to remove this video. Please try again later.",
            META: {
                TITLE: "History - Reallusion Courses",
                DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
                OG_TITLE: "History - Reallusion Courses",
                OG_DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
            },
        },
        PAGE_MASTER_CLASS: {
            MASTER_CLASS: "Master Class",
            EXPLORE_3D_WORLD: "EXPLORE 3D WORLD",
            EXPLORE_2D_WORLD: "EXPLORE 2D WORLD",
            EXPLORE_2D_3D_CONVERSION: "EXPLORE 2D/3D CONVERSION",
            META: {
                TITLE: "Master Class - Reallusion Courses",
                DESCRIPTION: "Learn from hands-on courses taught by the experts of every aspect of the 2D and 3D animation industry.",
                OG_TITLE: "Master Class - Reallusion Courses",
                OG_DESCRIPTION: "Learn from hands-on courses taught by the experts of every aspect of the 2D and 3D animation industry.",
            },
        },
        ONLINE_MANUAL: {
            NAME: "Online Manual",
            TAB_3D_ANIMATION: "3D Animation",
            TAB_2D_ANIMATION: "2D Animation",
            TAB_OTHERS: "Others",
            OUTLINE_MANUAL: "Online Manual",
            MAIN_PRODUCT: "Main Product",
            ICLONE_PLUG_IN: "iClone Plug-in",
            CHARACTER_PLUG_IN: "Character Creator Plug-in",
            CARTOON_ANIMATOR_PLUG_IN: "Cartoon Animator Plug-in",
            LEARN: "Learn",
            META: {
                TITLE: "Online Manual - Reallusion Courses",
                DESCRIPTION: "Looking for comprehensive, step-by-step instructions for 2D or 3D animation? Check out the online manual and tutorial links for iClone, Character Creator, Cartoon Animator, and ActorCore.",
                OG_TITLE: "Online Manual - Reallusion Courses",
                OG_DESCRIPTION: "Looking for comprehensive, step-by-step instructions for 2D or 3D animation? Check out the online manual and tutorial links for iClone, Character Creator, Cartoon Animator, and ActorCore.",
            },
        },
        SIDEBAR: {
            HOME: "Home",
            LIBRARY: "Library",
            MASTER_CLASS: "Master Class",
            SKILL_PATH: "Skill Paths",
            WEBINAR: "Webinar",
            BOOKMARK: "Bookmark",
            HISTORY: "History",
            ONLINE_MANUAL: "Online Manual"
        },
        VIEW_MODE: {
            CARDS: "Cards",
            DETAILS: "Details",
        },
        LOGIN: {
            PLEASE_LOG_IN: "Please Log In",
        },
        BOOKMARK: {
            META: {
                TITLE: "Bookmark - Reallusion Courses",
                DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
                OG_TITLE: "Bookmark - Reallusion Courses",
                OG_DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
            }
        },
        SKILL_PATH: {
            FILTER_TYPE: "All Type",
            LEVEL: 'Skill Level',
            LENGTH: 'Length',
            SOFTWARE: 'Software',
            SKILL_REQUIREMENT: 'Skill Requirement',
            VIDEO_OUTLINE: 'Video Series Outline',
            VIDEO_LENGTH: {
                HOUR: 'hour',
                MINUTE: 'min',
                SECOND: 's'
            },
            NO_VIDEO: 'No Skill Path videos yet',
            VIEW_MORE: 'View more',
            VIEW_LESS: 'View less'
        }
    },
    de: {
        COMMON: {
            TUTOTIAL: "Tutorial ",
            VERSION: "Version ",
            PRICE: "Preis ",
            DATE: "Datum ",
            LEVEL: "Stufe ",
            lEVEL_FOUNDATIONALl: "Grundlegend ",
            lEVEL_MEDIUM: "Mittel ",
            lEVEL_ADVANCED: "Fortschrittlich ",
            SORT_LATEST: "Neueste ",
            SORT_OLDEST: "Älteste ",
            SORT_RELEVANCE: "Relevanz ",
            HOSTED: "Veranstaltet von ",
            LIVE_DEMO_OUTLINE: "Live-Demo-Übersicht ",
            UPDATE_BOOKMARK_STATUS_SUCCESS: "Erfolgreich mit einem Lesezeichen versehen ",
            UPDATE_CANCEL_BOOKMARK_STATUS_SUCCESS: "Aus Ihrem Lesezeichen entfernt ",
            API_ERROR_TITLE: `<div class="api-error-message-title">Fehler!</div>`,
            API_ERROR_DESCRIPTION: `<div class="api-error-message-content">Bitte versuchen Sie es später erneut.</div>`,
            NEW: "NEU ",
            NO_SEARCH_RESULTS_FOUND: "Es wurden keine Suchergebnisse gefunden. ",
            REALLUSION_COURSES: "Reallusion Courses",
            SKILL_PATH: 'Fähigkeitspfad'
        },
        PAGE_BOOKMARK: {
            BOOKMARK: "Lesezeichen ",
            NO_VIDEO: "Es wurden noch keine Videos mit einem Lesezeichen versehen. ",
            FILTER_ALL: "Alle ",
        },
        TOP_NAV: {
            LOG_IN: "Einloggen ",
            SIGN_UP: "Anmelden ",
            LOG_OUT: "Ausloggen ",
            BOOKMARK: "Lesezeichen ",
            HISTORY: "Historie ",
        },
        HOME: {
            NAME: "Home ",
            SEARCH_TITLE: "REALLUSION COURSES ",
            SEARCH_DESC: "Eine kostenlose Lernplattform, die schrittweise Videokurse und praktische Webinare anbietet. ",
            SEARCH_PLACEHOLDER: "Kostenlose Online-Tutorials durchsuchen ",
            GROUP_TITLE: "WÄHLEN SIE EIN PRODUKT ZUM LERNEN AUS. ",
            TEXT_BANNER: {
                TITLE: "Exklusiv für Schüler und Lehrer - Sparen Sie <span style=\"color: #ff5722\">60%</span> bei Reallusion Softwares",
                URL: "https://www.reallusion.com/de/global-training/educational-licensing.html#for-students-and-teachers-disable-scroll"
            },
            BANNER_TITLE: "ENTDECKEN SIE EMPFOHLENE KURSE. ",
            TITLE_SUPPORT: "COMMUNITY & SUPPORT ",
            MAGAZINE: "Blog ",
            MAGAZINE_LINK: "https://blog-de.reallusion.com/",
            MAGAZINE_DESC: "Erhalten Sie die Reallusion Neuigkeiten, lernen Sie von unseren Power-Usern und finden Sie die besten Showcases. ",
            FORUM: "Forum ",
            FORUM_LINK: "https://discussions.reallusion.com/",
            FORUM_DESC: "Lernen Sie von erfahrenen Benutzern und teilen Sie Ihre Ideen mit der Community. ",
            DEVELOPER_CENTER: "Developer Center ",
            DEVELOPER_CENTER_LINK: "https://developer.reallusion.com/default.html",
            DEVELOPER_CENTER_DESC: "Werden Sie zertifizierter Reallusion Entwickler, um digitale Inhalte oder Plug-Ins zu erstellen. ",
            FAQ: "FAQ ",
            FAQ_LINK: "https://kb.reallusion.com/Default.aspx?lang=8",
            FAQ_DESC: "Erhalten Sie schnelle Antworten auf häufig gestellte Fragen zu Installation, Mitgliedschaft und Käufen. ",
            CUSTOMER_SERVICE: "Kundendienst ",
            CUSTOMER_SERVICE_LINK: "https://www.reallusion.com/de/CustomerSupport/UserEx/QForm.html",
            CUSTOMER_SERVICE_DESC: "Melden Sie sich bei Ihrem Mitgliedskonto an, um ein Support-Ticket zur Problemlösung einzureichen. ",
            FEEDBACK_TRACKER: "Feedback Tracker ",
            FEEDBACK_TRACKER_LINK: "https://www.reallusion.com/FeedBackTracker/",
            FEEDBACK_TRACKER_DESC: "Teilen Sie Ihre Vorschläge zur Produktverbesserung und Entwicklungszyklen. ",
            META: {
                TITLE: "Reallusion Courses - Kostenlose Online-Tutorials für 2D- & 3D-Animationen ",
                DESCRIPTION: "Erweitern Sie Ihre 2D- und 3D-Animationsfähigkeiten in iClone, Character Creator & Cartoon Animator.Lernen Sie jetzt mit dem mit kostenlosen Lehrvideos und Webinaren. ",
                OG_TITLE: "Reallusion Courses - Kostenlose Online-Tutorials für 2D- & 3D-Animationen ",
                OG_DESCRIPTION: "Erweitern Sie Ihre 2D- und 3D-Animationsfähigkeiten in iClone, Character Creator & Cartoon Animator.Lernen Sie jetzt mit dem mit kostenlosen Lehrvideos und Webinaren. ",
            }
        },
        HOME_EXPLORER: {
            META: {
                ICLONE: {
                    TITLE: "iClone Tutorials - Reallusion Courses ",
                    DESCRIPTION: "Lernen Sie 3D-Animationserstellung in iClone gratis.",
                    OG_TITLE: "iClone Tutorials - Reallusion Courses ",
                    OG_DESCRIPTION: "Lernen Sie 3D-Animationserstellung in iClone gratis.",
                },
                CHARACTER_CREATOR: {
                    TITLE: "Character Creator Tutorials - Reallusion Courses ",
                    DESCRIPTION: "Lernen Sie Charaktererstellung in Character Creator gratis. ",
                    OG_TITLE: "Character Creator Tutorials - Reallusion Courses ",
                    OG_DESCRIPTION: "Lernen Sie Charaktererstellung in Character Creator gratis. ",
                },
                CARTOON_ANIMATOR: {
                    TITLE: "Cartoon Animator Tutorials - Reallusion Courses ",
                    DESCRIPTION: "Lernen Sie 2D-Animationserstellung in Cartoon Animator gratis. ",
                    OG_TITLE: "Cartoon Animator Tutorials - Reallusion Courses ",
                    OG_DESCRIPTION: "Lernen Sie 2D-Animationserstellung in Cartoon Animator gratis. ",
                },
                ACTORCORE: {
                    TITLE: "ActorCore Tutorials - Reallusion Courses ",
                    DESCRIPTION: "Erfahren Sie, wie Sie Actorcore, die beste 3D-Mocap-Asset-Plattform, verwenden. ",
                    OG_TITLE: "ActorCore Tutorials - Reallusion Courses ",
                    OG_DESCRIPTION: "Erfahren Sie, wie Sie Actorcore, die beste 3D-Mocap-Asset-Plattform, verwenden. ",
                },
                SMART_GALLERY: {
                    TITLE: "Smart Content Manager Tutorials - Reallusion Courses ",
                    DESCRIPTION: "Erfahren Sie, wie Sie Smart Content Manager verwenden und Ihre Assets kostenlos verwalten. ",
                    OG_TITLE: "Smart Content Manager Tutorials - Reallusion Courses ",
                    OG_DESCRIPTION: "Erfahren Sie, wie Sie Smart Content Manager verwenden und Ihre Assets kostenlos verwalten. ",
                },
            }
        },
        VIDEO_DETAIL: {
            TITLE_DESCRIPTION: "Beschreibung & Referenz ",
            TITLE_RELEVANCE: "Relevanz ",
            SPEAKERS: "Veranstaltet von ",
            TUTORIAL: "Tutorial ",
            FREE: "Kostenlos ",
            RESOURCE: "Ressourcen ",
            ONLINE_MANUAL: "Online-Handbuch ",
            TUTORIAL_ARTICLES: "Tutorial-Artikel ",
            DOWNLOAD_FILES: "Dateien herunterladen ",
            INSTRUCTOR: "Lehrer ",
        },
        LIBRARY: {
            FILTER_PRODUCT: "Alle Produkte ",
            FILTER_VERSION: "Alle Versionen ",
            FILTER_LEVEL: "Alle Stufen ",
            CLEAN_FILTER: "FILTER ENTFERNEN ",
            RESULTS: "Ergebnisse ",
            FILTER_TITLE: "SORTIEREN & FILTERN ",
            FILTER: "FILTER ",
            SORTING: "SORTIERUNG ",
            SORTING_BY: "Sort by",
            SEARCH_PLACEHOLDER: "Suche ",
            META: {
                TITLE: "Nach Tutorials suchen - Reallusion Courses ",
                DESCRIPTION: "Suchen Sie nach einem Thema? Geben Sie die Schlüsselwörter ein und suchen Sie nach den Tutorials. ",
                OG_TITLE: "Nach Tutorials suchen - Reallusion Courses ",
                OG_DESCRIPTION: "Suchen Sie nach einem Thema? Geben Sie die Schlüsselwörter ein und suchen Sie nach den Tutorials. ",
            },
        },
        WEBINAR: {
            NAME: "Webinar (EN) ",
            META: {
                TITLE: "Webinar - Reallusion Courses ",
                DESCRIPTION: "Watch Reallusion live webinar to learn tips or connect and interact with our professional instructors.",
                OG_TITLE: "Webinar - Reallusion Courses ",
                OG_DESCRIPTION: "Watch Reallusion live webinar to learn tips or connect and interact with our professional instructors.",
            },
        },
        HISTORY: {
            CLEAN_ALL_HISTORY: "Alle Aufrufe dieses Videos aus dem Verlauf entfernen ",
            FILTER_TYPE: "Alle Arten ",
            REMOVE_FROM_WATCH_HISTORY: "Aus dem Verlauf entfernen ",
            REMOVE_ALL_HISTORY: "Alle Aufrufe dieses Videos aus dem Verlauf entfernen ",
            REMOVE_VIDEO_HISTORY: "Dieses Video wurde aus dem Verlauf entfernt. ",
            REMOVE_HISTORY_ERROR: "Dieses Video konnte nicht entfernt werden. Bitte versuchen Sie es später erneut. ",
            META: {
                TITLE: "Historie - Reallusion Courses",
                DESCRIPTION: "Erweitern Sie Ihre 2D- und 3D-Animationsfähigkeiten in iClone, Character Creator & Cartoon Animator.Lernen Sie jetzt mit dem mit kostenlosen Lehrvideos und Webinaren. ",
                OG_TITLE: "Historie - Reallusion Courses",
                OG_DESCRIPTION: "Erweitern Sie Ihre 2D- und 3D-Animationsfähigkeiten in iClone, Character Creator & Cartoon Animator.Lernen Sie jetzt mit dem mit kostenlosen Lehrvideos und Webinaren. ",
            },
        },
        PAGE_MASTER_CLASS: {
            MASTER_CLASS: "Master Class ",
            EXPLORE_3D_WORLD: "3D-WELT ERKUNDEN ",
            EXPLORE_2D_WORLD: "2D-WELT ERKUNDEN ",
            EXPLORE_2D_3D_CONVERSION: "2D/3D-KONVERTIERUNG ERKUNDEN ",
            META: {
                TITLE: "Master Class - Reallusion Courses ",
                DESCRIPTION: "Lernen Sie praktische Kurse von Meistern. ",
                OG_TITLE: "Master Class - Reallusion Courses ",
                OG_DESCRIPTION: "Lernen Sie praktische Kurse von Meistern. ",
            },
        },
        ONLINE_MANUAL: {
            NAME: "Online-Handbuch ",
            TAB_3D_ANIMATION: "3D-Animation ",
            TAB_2D_ANIMATION: "2D-Animation ",
            TAB_OTHERS: "Andere ",
            OUTLINE_MANUAL: "Online-Handbuch ",
            MAIN_PRODUCT: "Hauptprodukt ",
            ICLONE_PLUG_IN: "iClone Plug-in ",
            CHARACTER_PLUG_IN: "Character Creator Plug-in ",
            CARTOON_ANIMATOR_PLUG_IN: "Cartoon Animator Plug-in ",
            LEARN: "Lernen ",
            META: {
                TITLE: "Online Manual - Reallusion Courses ",
                DESCRIPTION: "Suchen Sie nach ausführlichen Anweisungen? Link zum Online-Handbuch für umfassende Einführungen. ",
                OG_TITLE: "Online Manual - Reallusion Courses ",
                OG_DESCRIPTION: "Suchen Sie nach ausführlichen Anweisungen? Link zum Online-Handbuch für umfassende Einführungen. ",
            },
        },
        SIDEBAR: {
            HOME: "Home ",
            LIBRARY: "Bibliothek ",
            MASTER_CLASS: "Master Class ",
            SKILL_PATH: "Fähigkeitspfad",
            WEBINAR: "Webinar (EN)",
            BOOKMARK: "Lesezeichen ",
            HISTORY: "Historie ",
            ONLINE_MANUAL: "Online-Handbuch ",
        },
        VIEW_MODE: {
            CARDS: "Karten ",
            DETAILS: "Details ",
        },
        LOGIN: {
            PLEASE_LOG_IN: "Bitte loggen Sie sich ein. ",
        },
        BOOKMARK: {
            META: {
                TITLE: "Lesezeichen - Reallusion Courses",
                DESCRIPTION: "Erweitern Sie Ihre 2D- und 3D-Animationsfähigkeiten in iClone, Character Creator & Cartoon Animator.Lernen Sie jetzt mit dem mit kostenlosen Lehrvideos und Webinaren.",
                OG_TITLE: "Lesezeichen - Reallusion Courses",
                OG_DESCRIPTION: "Erweitern Sie Ihre 2D- und 3D-Animationsfähigkeiten in iClone, Character Creator & Cartoon Animator.Lernen Sie jetzt mit dem mit kostenlosen Lehrvideos und Webinaren. ",
            }
        },
        SKILL_PATH: {
            FILTER_TYPE: "Alle Arten",
            LEVEL: 'Skill Level',
            LENGTH: 'Length',
            SOFTWARE: 'Software',
            SKILL_REQUIREMENT: 'Skill Requirement',
            VIDEO_OUTLINE: 'Video Series Outline',
            VIDEO_LENGTH: {
                HOUR: 'hr',
                MINUTE: 'min',
                SECOND: 's'
            },
            NO_VIDEO: 'No Skill Path videos yet',
            VIEW_MORE: 'View more',
            VIEW_LESS: 'View less'
        }
    },
    jp: {
        COMMON: {
            TUTOTIAL: "チュートリアル ",
            VERSION: "バージョン ",
            PRICE: "価格 ",
            DATE: "日付 ",
            LEVEL: "レベル ",
            lEVEL_FOUNDATIONALl: "基礎 ",
            lEVEL_MEDIUM: "中級 ",
            lEVEL_ADVANCED: "上級 ",
            SORT_LATEST: "最新 ",
            SORT_OLDEST: "最舊 ",
            SORT_RELEVANCE: "関連チュートリアル ",
            HOSTED: "講師 ",
            LIVE_DEMO_OUTLINE: "内容概要 ",
            UPDATE_BOOKMARK_STATUS_SUCCESS: "ブックマークに追加されました ",
            UPDATE_CANCEL_BOOKMARK_STATUS_SUCCESS: "ブックマークから削除されました ",
            API_ERROR_TITLE: `<div class="api-error-message-title">エラー！</div>`,
            API_ERROR_DESCRIPTION: `<div class="api-error-message-content">数分待ってから再試行してください。</div>`,
            NEW: "最新 ",
            NO_SEARCH_RESULTS_FOUND: "一致する検索結果がありません。 ",
            REALLUSION_COURSES: "Reallusion コース",
            SKILL_PATH: 'スキルパス'
        },
        PAGE_BOOKMARK: {
            BOOKMARK: "ブックマーク ",
            NO_VIDEO: "まだブックマークに追加されたビデオはありません ",
            FILTER_ALL: "すべて ",
        },
        TOP_NAV: {
            LOG_IN: "ログイン ",
            SIGN_UP: "サインアップ ",
            LOG_OUT: "ログアウト ",
            BOOKMARK: "ブックマーク ",
            HISTORY: "履歴 ",
        },
        HOME: {
            NAME: "ホーム ",
            SEARCH_TITLE: "REALLUSION コース ",
            SEARCH_DESC: "応用的かつ実用的なオンラインコースとウェビナーを提供する無料学習プラットフォーム。 ",
            SEARCH_PLACEHOLDER: "無料オンラインチュートリアルを検索する ",
            GROUP_TITLE: "学習したい製品を選択 ",
            TEXT_BANNER: {
                TITLE: "Reallusion クリエイティブソフトウェアが <span style=\"color: #ff5722\">60%</span> OFF - 学生と教師向け",
                URL: "https://www.reallusion.com/jp/global-training/educational-licensing.html#for-students-and-teachers-disable-scroll"
            },
            BANNER_TITLE: "おすすめのコースを探す ",
            TITLE_SUPPORT: "コミュニティ & サポート ",
            MAGAZINE: "ブログ ",
            MAGAZINE_LINK: "https://blog-jp.reallusion.com/",
            MAGAZINE_DESC: "Reallusion に関する最新情報やユーザー事例など役に立つ情報を紹介しています。 ",
            FORUM: "フォーラム (英) ",
            FORUM_LINK: "https://discussions.reallusion.com/",
            FORUM_DESC: "経験豊富なユーザーから学びます。そして、あなたの作品を共有してコメントをつけましょう。 ",
            DEVELOPER_CENTER: "開発者センター ",
            DEVELOPER_CENTER_LINK: "https://developer.reallusion.com/default.html",
            DEVELOPER_CENTER_DESC: "Reallusion の認定開発者となり、デジタルコンテンツまたはプラグインを作成して収入を得ることができます。 ",
            FAQ: "よくある質問 ",
            FAQ_LINK: "https://kb.reallusion.com/Default.aspx?lang=4",
            FAQ_DESC: "インストール、メンバーシップや購入に関するよくある質問への回答を示します。 ",
            CUSTOMER_SERVICE: "カスタマーサービス ",
            CUSTOMER_SERVICE_LINK: "https://www.reallusion.com/jp/CustomerSupport/UserEx/QForm.html",
            CUSTOMER_SERVICE_DESC: "サポートが必要な場合は、メンバーアカウントにログインして、サポートチケットを送信してください。 ",
            FEEDBACK_TRACKER: "Feedback Tracker (英) ",
            FEEDBACK_TRACKER_LINK: "https://www.reallusion.com/FeedBackTracker/",
            FEEDBACK_TRACKER_DESC: "当社製品に対するご意見・ご要望をお寄せ下さい。 ",
            META: {
                TITLE: "Reallusion コース | 2D & 3D アニメーションの無料オンラインチュートリアル ",
                DESCRIPTION: "iClone、Character Creator や Cartoon Animator の使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                OG_TITLE: "Reallusion コース | 2D & 3D アニメーションの無料オンラインチュートリアル ",
                OG_DESCRIPTION: "iClone、Character Creator や Cartoon Animator の使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
            },
        },
        HOME_EXPLORER: {
            META: {
                ICLONE: {
                    TITLE: "iClone チュートリアル | Reallusion コース ",
                    DESCRIPTION: "iClone 使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                    OG_TITLE: "iClone チュートリアル | Reallusion コース ",
                    OG_DESCRIPTION: "iClone 使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                },
                CHARACTER_CREATOR: {
                    TITLE: "Character Creator チュートリアル | Reallusion コース ",
                    DESCRIPTION: "Character Creator 使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                    OG_TITLE: "Character Creator チュートリアル | Reallusion コース ",
                    OG_DESCRIPTION: "Character Creator 使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                },
                CARTOON_ANIMATOR: {
                    TITLE: "Cartoon Animator チュートリアル | Reallusion コース ",
                    DESCRIPTION: "Cartoon Animator 使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                    OG_TITLE: "Cartoon Animator チュートリアル | Reallusion コース ",
                    OG_DESCRIPTION: "Cartoon Animator 使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                },
                ACTORCORE: {
                    TITLE: "Actorcore チュートリアル | Reallusion コース ",
                    DESCRIPTION: "3D アセットプラットフォームである Actorcore 使い方について詳しくご解説いたします。 ",
                    OG_TITLE: "Actorcore チュートリアル | Reallusion コース ",
                    OG_DESCRIPTION: "3D アセットプラットフォームである Actorcore 使い方について詳しくご解説いたします。 ",
                },
                SMART_GALLERY: {
                    TITLE: "Smart Content Manager チュートリアル | Reallusion コース ",
                    DESCRIPTION: "Smart Content Manager 使い方やアセット管理方法について詳しくご解説いたします。 ",
                    OG_TITLE: "Smart Content Manager チュートリアル | Reallusion コース ",
                    OG_DESCRIPTION: "Smart Content Manager 使い方やアセット管理方法について詳しくご解説いたします。 ",
                },
            }
        },
        VIDEO_DETAIL: {
            TITLE_DESCRIPTION: "説明 & 参考 ",
            TITLE_RELEVANCE: "関連チュートリアル ",
            SPEAKERS: "講師 ",
            TUTORIAL: "チュートリアル ",
            FREE: "無料 ",
            RESOURCE: "学習リソース ",
            ONLINE_MANUAL: "オンラインマニュアル ",
            TUTORIAL_ARTICLES: "チュートリアル記事 ",
            DOWNLOAD_FILES: "ファイルのダウンロード ",
            INSTRUCTOR: "認定トレーナー ",
        },
        LIBRARY: {
            FILTER_PRODUCT: "すべての製品 ",
            FILTER_VERSION: "すべてのバージョン ",
            FILTER_LEVEL: "すべてのレベル ",
            CLEAN_FILTER: "絞り込みを解除 ",
            RESULTS: "結果 ",
            FILTER_TITLE: "並べ替え & 絞り込み ",
            FILTER: "絞り込み ",
            SORTING: "並べ替え ",
            SORTING_BY: "Sort by",
            SEARCH_PLACEHOLDER: "検索 ",
            META: {
                TITLE: "チュートリアルの検索 | Reallusion コース ",
                DESCRIPTION: "どんなトピックをお探しですか？キーワードを入力し、検索してみてください。 ",
                OG_TITLE: "チュートリアルの検索 | Reallusion コース ",
                OG_DESCRIPTION: "どんなトピックをお探しですか？キーワードを入力し、検索してみてください。 ",
            },
        },
        WEBINAR: {
            NAME: "ウェビナー (英) ",
            META: {
                TITLE: "ウェビナー | Reallusion コース ",
                DESCRIPTION: "ウェビナーを通じて専門家と交流できます。 ",
                OG_TITLE: "ウェビナー | Reallusion コース ",
                OG_DESCRIPTION: "ウェビナーを通じて専門家と交流できます。 ",
            },
        },
        HISTORY: {
            CLEAN_ALL_HISTORY: "すべての閲覧履歴を削除 ",
            FILTER_TYPE: "すべてのタイプ ",
            REMOVE_FROM_WATCH_HISTORY: "閲覧履歴から削除する ",
            REMOVE_ALL_HISTORY: "この動画の閲覧データは履歴から削除されました ",
            REMOVE_VIDEO_HISTORY: "この動画は履歴から削除されました ",
            REMOVE_HISTORY_ERROR: "この動画を削除することができませんでした。もう一度やり直してください。 ",
            META: {
                TITLE: "履歴 | Reallusion コース ",
                DESCRIPTION: "iClone、Character Creator や Cartoon Animator の使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                OG_TITLE: "履歴 | Reallusion コース ",
                OG_DESCRIPTION: "iClone、Character Creator や Cartoon Animator の使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
            },
        },
        PAGE_MASTER_CLASS: {
            MASTER_CLASS: "上級クラス ",
            EXPLORE_3D_WORLD: "3D 世界を探索 ",
            EXPLORE_2D_WORLD: "2D 世界を探索 ",
            EXPLORE_2D_3D_CONVERSION: "2D/3D 変換を探索 ",
            META: {
                TITLE: "上級クラス | Reallusion コース ",
                DESCRIPTION: "達人に学び、上級スキルが身につきます。 ",
                OG_TITLE: "上級クラス | Reallusion コース ",
                OG_DESCRIPTION: "達人に学び、上級スキルが身につきます。 ",
            },
        },
        ONLINE_MANUAL: {
            NAME: "オンラインマニュアル ",
            TAB_3D_ANIMATION: "3D アニメーション ",
            TAB_2D_ANIMATION: "2D アニメーション ",
            TAB_OTHERS: "その他 ",
            OUTLINE_MANUAL: "オンラインマニュアル ",
            MAIN_PRODUCT: "主要製品 ",
            ICLONE_PLUG_IN: "iClone プラグイン ",
            CHARACTER_PLUG_IN: "Character Creator プラグイン ",
            CARTOON_ANIMATOR_PLUG_IN: "Cartoon Animator プラグイン ",
            LEARN: "トレーニングセンター ",
            META: {
                TITLE: "オンラインマニュアル | Reallusion コース ",
                DESCRIPTION: "詳細な説明をお探しですか？ お客様がご利用中の製品のオンラインマニュアルをご覧いただけます。 ",
                OG_TITLE: "オンラインマニュアル | Reallusion コース ",
                OG_DESCRIPTION: "詳細な説明をお探しですか？ お客様がご利用中の製品のオンラインマニュアルをご覧いただけます。 ",
            },
        },
        SIDEBAR: {
            HOME: "ホーム ",
            LIBRARY: "コース一覧 ",
            MASTER_CLASS: "上級クラス ",
            SKILL_PATH: "スキルパス",
            WEBINAR: "ウェビナー (英) ",
            BOOKMARK: "ブックマーク ",
            HISTORY: "履歴 ",
            ONLINE_MANUAL: "オンラインマニュアル ",
        },
        VIEW_MODE: {
            CARDS: "アイコン ",
            DETAILS: "詳細 ",
        },
        LOGIN: {
            PLEASE_LOG_IN: "ログインしてください ",
        },
        BOOKMARK: {
            META: {
                TITLE: "ブックマーク | Reallusion コース ",
                DESCRIPTION: "iClone、Character Creator や Cartoon Animator の使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
                OG_TITLE: "ブックマーク | Reallusion コース ",
                OG_DESCRIPTION: "iClone、Character Creator や Cartoon Animator の使い方について詳しくご解説いたします。オンラインチュートリアルとウェビナーで必要なテクニックを学び始めましょう。 ",
            }
        },
        SKILL_PATH: {
            FILTER_TYPE: "すべてのタイプ",
            LEVEL: 'Skill Level',
            LENGTH: 'Length',
            SOFTWARE: 'Software',
            SKILL_REQUIREMENT: 'Skill Requirement',
            VIDEO_OUTLINE: 'Video Series Outline',
            VIDEO_LENGTH: {
                HOUR: 'hr',
                MINUTE: 'min',
                SECOND: 's'
            },
            NO_VIDEO: 'No Skill Path videos yet',
            VIEW_MORE: 'View more',
            VIEW_LESS: 'View less'
        }
    },
    tw: {
        COMMON: {
            TUTOTIAL: "教學影片",
            VERSION: "版本",
            PRICE: "價格",
            DATE: "日期",
            LEVEL: "等級",
            lEVEL_FOUNDATIONALl: "基礎",
            lEVEL_MEDIUM: "中級",
            lEVEL_ADVANCED: "進階",
            SORT_LATEST: "最新消息",
            SORT_OLDEST: "最舊消息",
            SORT_RELEVANCE: "相關單元",
            HOSTED: "主講人",
            LIVE_DEMO_OUTLINE: "直播展示大綱",
            UPDATE_BOOKMARK_STATUS_SUCCESS: "已成功加入書籤",
            UPDATE_CANCEL_BOOKMARK_STATUS_SUCCESS: "已從您的書籤中刪除",
            API_ERROR_TITLE: `<div class="api-error-message-title">錯誤！</div>`,
            API_ERROR_DESCRIPTION: `<div class="api-error-message-content">請等待幾分鐘，然後再試一次。</div>`,
            NEW: "最新",
            NO_SEARCH_RESULTS_FOUND: "沒有找到搜尋結果。",
            REALLUSION_COURSES: "Reallusion 線上課程",
            SKILL_PATH: '系列課程'
        },
        PAGE_BOOKMARK: {
            BOOKMARK: "書籤",
            NO_VIDEO: "目前沒有影片被加入書籤中",
            FILTER_ALL: "全部",
        },
        TOP_NAV: {
            LOG_IN: "登入",
            SIGN_UP: "註冊",
            LOG_OUT: "登出",
            BOOKMARK: "書籤",
            HISTORY: "觀看紀錄",
        },
        HOME: {
            NAME: "首頁",
            SEARCH_TITLE: "REALLUSION 線上課程",
            SEARCH_DESC: "一個免費的學習平台，提供逐步的教學影片課程和網絡研討會。",
            SEARCH_PLACEHOLDER: "搜尋線上免費教學影片",
            GROUP_TITLE: "選擇想學習的產品",
            TEXT_BANNER: {
                TITLE: "為 Reallusion 創意軟體省下 <span style=\"color: #ff5722\">60%</span> - 學生及教師專屬",
                URL: "https://www.reallusion.com/tw/global-training/educational-licensing.html#for-students-and-teachers-disable-scroll"
            },
            BANNER_TITLE: "探索推薦課程",
            TITLE_SUPPORT: "社群 & 技術支援",
            MAGAZINE: "Blog",
            MAGAZINE_LINK: "https://blog-tw.reallusion.com/",
            MAGAZINE_DESC: "獲得 Reallusion 最新消息，向專業使用者學習並探索最棒的使用者案例。",
            FORUM: "論壇",
            FORUM_LINK: "https://discussions.reallusion.com/",
            FORUM_DESC: "向有經驗的使用者學習，分享您的創作並發表評論。",
            DEVELOPER_CENTER: "開發者中心",
            DEVELOPER_CENTER_LINK: "https://developer.reallusion.com/default.html",
            DEVELOPER_CENTER_DESC: "加入 Reallusion 並成為認證開發者以創作數位內容及外掛。",
            FAQ: "常見問題",
            FAQ_LINK: "https://kb.reallusion.com/Default.aspx?lang=2",
            FAQ_DESC: "獲得有關安裝、會員資格和購買的常見問題的快速解答。",
            CUSTOMER_SERVICE: "客戶服務",
            CUSTOMER_SERVICE_LINK: "https://www.reallusion.com/tw/CustomerSupport/UserEx/QForm.html",
            CUSTOMER_SERVICE_DESC: "對於任何問題解決的需求，請登錄您的會員帳戶並提交問題表單。",
            FEEDBACK_TRACKER: "Feedback Tracker",
            FEEDBACK_TRACKER_LINK: "https://www.reallusion.com/FeedBackTracker/",
            FEEDBACK_TRACKER_DESC: "透過分享您的建議，參與我們的產品改進和開發週期。",
            META: {
                TITLE: "Reallusion 線上課程 - 免費線上 2D & 3D 動畫教學影片",
                DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 動畫技能。立即透過免費教學影片和網絡研討會開始學習。",
                OG_TITLE: "Reallusion 線上課程 - 免費線上 2D & 3D 動畫教學影片",
                OG_DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 動畫技能。立即透過免費教學影片和網絡研討會開始學習。",
            },
        },
        HOME_EXPLORER: {
            META: {
                ICLONE: {
                    TITLE: "iClone 教學影片 - Reallusion 線上課程",
                    DESCRIPTION: "在 iClone 中學習 3D 動畫技巧。",
                    OG_TITLE: "iClone 教學影片 - Reallusion 線上課程",
                    OG_DESCRIPTION: "在 iClone 中學習 3D 動畫技巧。",
                },
                CHARACTER_CREATOR: {
                    TITLE: "Character Creator 教學影片 - Reallusion 線上課程",
                    DESCRIPTION: "在 Character Creator 中學習創建角色。",
                    OG_TITLE: "Character Creator 教學影片 - Reallusion 線上課程",
                    OG_DESCRIPTION: "在 Character Creator 中學習創建角色。",
                },
                CARTOON_ANIMATOR: {
                    TITLE: "Cartoon Animator 教學影片 - Reallusion 線上課程",
                    DESCRIPTION: "在 Cartoon Animator  中學習 2D 動畫技巧。",
                    OG_TITLE: "Cartoon Animator 教學影片 - Reallusion 線上課程",
                    OG_DESCRIPTION: "在 Cartoon Animator  中學習 2D 動畫技巧。",
                },
                ACTORCORE: {
                    TITLE: "ActorCore 教學影片 - Reallusion 線上課程",
                    DESCRIPTION: "了解如何使用世界上最好的人體動作捕捉 3D 運動平台 ActorCore。",
                    OG_TITLE: "ActorCore - Reallusion 線上課程",
                    OG_DESCRIPTION: "了解如何使用世界上最好的人體動作捕捉 3D 運動平台 ActorCore。",
                },
                SMART_GALLERY: {
                    TITLE: "Smart Content Manager 教學影片 - Reallusion 線上課程",
                    DESCRIPTION: "了解如何使用 Smart Content Manager 和管理您的素材資產。",
                    OG_TITLE: "Smart Content Manager 教學影片 - Reallusion 線上課程",
                    OG_DESCRIPTION: "了解如何使用 Smart Content Manager 和管理您的素材資產。",
                },
            },
        },
        VIDEO_DETAIL: {
            TITLE_DESCRIPTION: "描述和參考",
            TITLE_RELEVANCE: "相關單元",
            SPEAKERS: "主講人",
            TUTORIAL: "教學影片",
            FREE: "免費",
            RESOURCE: "學習資源",
            ONLINE_MANUAL: "線上使用手冊",
            TUTORIAL_ARTICLES: "教學文章",
            DOWNLOAD_FILES: "檔案下載",
            INSTRUCTOR: "講師",
        },
        LIBRARY: {
            FILTER_PRODUCT: "所有產品",
            FILTER_VERSION: "所有版本",
            FILTER_LEVEL: "所有等級",
            CLEAN_FILTER: "清空條件",
            RESULTS: "結果",
            FILTER_TITLE: "排序與條件",
            FILTER: "條件",
            SORTING: "排序與條件",
            SORTING_BY: "Sort by",
            SEARCH_PLACEHOLDER: "搜尋",
            META: {
                TITLE: "搜尋教學影片 - Reallusion 線上課程",
                DESCRIPTION: "正在尋找任何主題嗎？輸入關鍵字並搜尋課程。",
                OG_TITLE: "搜尋教學影片 - Reallusion 線上課程",
                OG_DESCRIPTION: "正在尋找任何主題嗎？輸入關鍵字並搜尋課程。",
            },
        },
        WEBINAR: {
            NAME: "線上研討會 (英)",
            META: {
                TITLE: "網路研討會 - Reallusion 線上課程",
                DESCRIPTION: "透過網路研討會，與專家們聯繫、互動",
                OG_TITLE: "網路研討會 - Reallusion 線上課程",
                OG_DESCRIPTION: "透過網路研討會，與專家們聯繫、互動",
            },
        },
        HISTORY: {
            CLEAN_ALL_HISTORY: "清除所有觀看紀錄",
            FILTER_TYPE: "所有類型",
            REMOVE_FROM_WATCH_HISTORY: "從觀看紀錄中移除",
            REMOVE_ALL_HISTORY: "此視頻中的觀看次數已全數從觀看紀錄中移除",
            REMOVE_VIDEO_HISTORY: "此視頻已從觀看紀錄中移除",
            REMOVE_HISTORY_ERROR: "無法移除此視頻，請稍後再試一次",
            META: {
                TITLE: "觀看紀錄 - Reallusion 線上課程",
                DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 動畫技能。立即透過免費教學影片和網絡研討會開始學習。",
                OG_TITLE: "觀看紀錄 - Reallusion 線上課程",
                OG_DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 動畫技能。立即透過免費教學影片和網絡研討會開始學習。",
            },
        },
        PAGE_MASTER_CLASS: {
            MASTER_CLASS: "大師課程",
            EXPLORE_3D_WORLD: "探索 3D 領域",
            EXPLORE_2D_WORLD: "探索 2D 領域",
            EXPLORE_2D_3D_CONVERSION: "探索 2D/3D 之間的轉換",
            META: {
                TITLE: "大師課程 - Reallusion 線上課程",
                DESCRIPTION: "向大師學習實踐課程。",
                OG_TITLE: "大師課程 - Reallusion 線上課程",
                OG_DESCRIPTION: "向大師學習實踐課程。",
            },
        },
        ONLINE_MANUAL: {
            NAME: "線上指南",
            TAB_3D_ANIMATION: "3D 動畫",
            TAB_2D_ANIMATION: "2D 動畫",
            TAB_OTHERS: "其他",
            OUTLINE_MANUAL: "線上指南",
            MAIN_PRODUCT: "主要產品",
            ICLONE_PLUG_IN: "iClone 外掛",
            CHARACTER_PLUG_IN: "Character Creator 外掛",
            CARTOON_ANIMATOR_PLUG_IN: "Cartoon Animator 外掛",
            LEARN: "學習中心",
            META: {
                TITLE: "線上指南 - Reallusion 線上課程",
                DESCRIPTION: "正在尋找詳細使用說明？前往線上指南獲得全面介紹。",
                OG_TITLE: "線上指南 - Reallusion 線上課程",
                OG_DESCRIPTION: "正在尋找詳細使用說明？前往線上指南獲得全面介紹。",
            },
        },
        SIDEBAR: {
            HOME: "首頁",
            LIBRARY: "資料庫",
            MASTER_CLASS: "大師課程",
            SKILL_PATH: "系列課程",
            WEBINAR: "線上研討會 (英)",
            BOOKMARK: "書籤",
            HISTORY: "觀看紀錄",
            ONLINE_MANUAL: "線上指南",
        },
        VIEW_MODE: {
            CARDS: "圖示",
            DETAILS: "詳細資料",
        },
        LOGIN: {
            PLEASE_LOG_IN: "請登錄",
        },
        BOOKMARK: {
            META: {
                TITLE: "書籤 - Reallusion 線上課程",
                DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
                OG_TITLE: "書籤 - Reallusion 線上課程",
                OG_DESCRIPTION: "Level up your 2D or 3D animation skills in iClone, Character Creator and Cartoon Animator for free.",
            }
        },
        SKILL_PATH: {
            FILTER_TYPE: "所有類型",
            LEVEL: 'Skill Level',
            LENGTH: 'Length',
            SOFTWARE: 'Software',
            SKILL_REQUIREMENT: 'Skill Requirement',
            VIDEO_OUTLINE: 'Video Series Outline',
            VIDEO_LENGTH: {
                HOUR: 'hr',
                MINUTE: 'min',
                SECOND: 's'
            },
            NO_VIDEO: 'No Skill Path videos yet',
            VIEW_MORE: 'View more',
            VIEW_LESS: 'View less'
        }
    },
    cn: {
        COMMON: {
            TUTOTIAL: "教学视频",
            VERSION: "版本",
            PRICE: "价格",
            DATE: "日期",
            LEVEL: "等级",
            lEVEL_FOUNDATIONALl: "基础",
            lEVEL_MEDIUM: "中级",
            lEVEL_ADVANCED: "高级",
            SORT_LATEST: "最新消息",
            SORT_OLDEST: "最旧消息",
            SORT_RELEVANCE: "相关单元",
            HOSTED: "主讲人",
            LIVE_DEMO_OUTLINE: "直播展示大纲",
            UPDATE_BOOKMARK_STATUS_SUCCESS: "已成功添加书签",
            UPDATE_CANCEL_BOOKMARK_STATUS_SUCCESS: "已从您的书签中删除",
            API_ERROR_TITLE: `<div class="api-error-message-title">错误！</div>`,
            API_ERROR_DESCRIPTION: `<div class="api-error-message-content">请等待几分钟，然后再试一次。</div>`,
            NEW: "最新",
            NO_SEARCH_RESULTS_FOUND: "没有找到搜索结果。",
            REALLUSION_COURSES: "Reallusion 在线课程",
            SKILL_PATH: '系列課程'
        },
        PAGE_BOOKMARK: {
            BOOKMARK: "书签",
            NO_VIDEO: "当前没有视频被添加书签中",
            FILTER_ALL: "全部",
        },
        TOP_NAV: {
            LOG_IN: "登录",
            SIGN_UP: "注册",
            LOG_OUT: "注销",
            BOOKMARK: "书签",
            HISTORY: "观看纪录",
        },
        HOME: {
            NAME: "首页",
            SEARCH_TITLE: "REALLUSION 在线课程",
            SEARCH_DESC: "一个免费的学习平台，提供逐步的教学视频课程和网络研讨会。",
            SEARCH_PLACEHOLDER: "搜索在线免费教学视频",
            GROUP_TITLE: "选择想学习的产品",
            TEXT_BANNER: {
                TITLE: "为 Reallusion 创意软体省下 <span style=\"color: #ff5722\">60%</span> - 学生及教师专属",
                URL: "https://www.reallusion.com/cn/global-training/educational-licensing.html#for-students-and-teachers-disable-scroll"
            },
            BANNER_TITLE: "探索推荐课程",
            TITLE_SUPPORT: "社区 & 技术支持",
            MAGAZINE: "Blog",
            MAGAZINE_LINK: "https://mp.weixin.qq.com/s/5Gw_Wj35auHJK98vjOr6vg",
            MAGAZINE_DESC: "获得 Reallusion 最新消息，向专业用户学习并探索最棒的用户案例。",
            FORUM: "论坛",
            FORUM_LINK: "https://discussions.reallusion.com/",
            FORUM_DESC: "向有经验的用户学习，分享您的创作并发表评论。",
            DEVELOPER_CENTER: "开发者中心",
            DEVELOPER_CENTER_LINK: "https://developer.reallusion.com/default.html",
            DEVELOPER_CENTER_DESC: "添加 Reallusion 并成为认证开发者以创作数字内容及外挂。",
            FAQ: "常见问题",
            FAQ_LINK: "https://kb.reallusion.com/Default.aspx?lang=2",
            FAQ_DESC: "获得有关安装、会员资格和购买的常见问题的快速解答。",
            CUSTOMER_SERVICE: "客户服务",
            CUSTOMER_SERVICE_LINK: "https://www.reallusion.com/cn/CustomerSupport/UserEx/QForm.html",
            CUSTOMER_SERVICE_DESC: "对于任何问题解决的需求，请登录您的会员帐户并提交问题表单。",
            FEEDBACK_TRACKER: "Feedback Tracker",
            FEEDBACK_TRACKER_LINK: "https://www.reallusion.com/FeedBackTracker/",
            FEEDBACK_TRACKER_DESC: "透过分享您的建议，参与我们的产品改进和开发周期。",
            META: {
                TITLE: "Reallusion 在线课程 - 免费在线 2D & 3D 动画教学视频",
                DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 动画技能。立即透过免费教学视频和网络研讨会开始学习。",
                OG_TITLE: "Reallusion 在线课程 - 免费在线 2D & 3D 动画教学视频",
                OG_DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 动画技能。立即透过免费教学视频和网络研讨会开始学习。",
            },
        },
        HOME_EXPLORER: {
            META: {
                ICLONE: {
                    TITLE: "iClone 教学视频 - Reallusion 在线课程",
                    DESCRIPTION: "在 iClone 中学习 3D 动画技巧。",
                    OG_TITLE: "iClone 教学视频 - Reallusion 在线课程",
                    OG_DESCRIPTION: "在 iClone 中学习 3D 动画技巧。",
                },
                CHARACTER_CREATOR: {
                    TITLE: "Character Creator 教学视频 - Reallusion 在线课程",
                    DESCRIPTION: "在 Character Creator 中学习创建角色。",
                    OG_TITLE: "Character Creator 教学视频 - Reallusion 在线课程",
                    OG_DESCRIPTION: "在 Character Creator 中学习创建角色。",
                },
                CARTOON_ANIMATOR: {
                    TITLE: "Cartoon Animator 教学视频 - Reallusion 在线课程",
                    DESCRIPTION: "在 Cartoon Animator  中学习 2D 动画技巧。",
                    OG_TITLE: "Cartoon Animator 教学视频 - Reallusion 在线课程",
                    OG_DESCRIPTION: "在 Cartoon Animator  中学习 2D 动画技巧。",
                },
                ACTORCORE: {
                    TITLE: "ActorCore 教学视频 - Reallusion 在线课程",
                    DESCRIPTION: "了解如何使用世界上最好的人体动作捕捉 3D 运动平台 ActorCore。",
                    OG_TITLE: "ActorCore 教学视频 - Reallusion 在线课程",
                    OG_DESCRIPTION: "了解如何使用世界上最好的人体动作捕捉 3D 运动平台 ActorCore。",
                },
                SMART_GALLERY: {
                    TITLE: "Smart Content Manager 教学视频 - Reallusion 在线课程",
                    DESCRIPTION: "了解如何使用 Smart Content Manager 和管理您的素材资产。",
                    OG_TITLE: "Smart Content Manager 教学视频 - Reallusion 在线课程",
                    OG_DESCRIPTION: "了解如何使用 Smart Content Manager 和管理您的素材资产。",
                },
            },
        },
        VIDEO_DETAIL: {
            TITLE_DESCRIPTION: "描述和参考",
            TITLE_RELEVANCE: "相关单元",
            SPEAKERS: "主讲人",
            TUTORIAL: "教学视频",
            FREE: "免费",
            RESOURCE: "学习资源",
            ONLINE_MANUAL: "在线使用手册",
            TUTORIAL_ARTICLES: "教学文章",
            DOWNLOAD_FILES: "文档下载",
            INSTRUCTOR: "讲师",
        },
        LIBRARY: {
            FILTER_PRODUCT: "所有产品",
            FILTER_VERSION: "所有版本",
            FILTER_LEVEL: "所有等级",
            CLEAN_FILTER: "清空条件",
            RESULTS: "结果",
            FILTER_TITLE: "排序与条件",
            FILTER: "条件",
            SORTING: "排序与条件",
            SORTING_BY: "Sort by",
            SEARCH_PLACEHOLDER: "搜索",
            META: {
                TITLE: "搜索教学视频 - Reallusion 在线课程",
                DESCRIPTION: "正在寻找任何主题吗？导入关键字并搜索课程。",
                OG_TITLE: "搜索教学视频 - Reallusion 在线课程",
                OG_DESCRIPTION: "正在寻找任何主题吗？导入关键字并搜索课程。",
            },
        },
        WEBINAR: {
            NAME: "网络研讨会 (英)",
            META: {
                TITLE: "网络研讨会 - Reallusion 在线课程",
                DESCRIPTION: "透过网络研讨会，与专家们联系、交互",
                OG_TITLE: "网络研讨会 - Reallusion 在线课程",
                OG_DESCRIPTION: "透过网络研讨会，与专家们联系、交互",
            },
        },
        HISTORY: {
            CLEAN_ALL_HISTORY: "清除所有观看纪录",
            FILTER_TYPE: "所有类型",
            REMOVE_FROM_WATCH_HISTORY: "从观看纪录中删除",
            REMOVE_ALL_HISTORY: "此视频中的观看次数已全数从观看纪录中删除",
            REMOVE_VIDEO_HISTORY: "此视频已从观看纪录中删除",
            REMOVE_HISTORY_ERROR: "无法删除此视频，请稍后再试一次",
            META: {
                TITLE: "观看纪录 - Reallusion 在线课程",
                DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 动画技能。立即透过免费教学视频和网络研讨会开始学习。",
                OG_TITLE: "观看纪录 - Reallusion 在线课程",
                OG_DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 动画技能。立即透过免费教学视频和网络研讨会开始学习。",
            },
        },
        PAGE_MASTER_CLASS: {
            MASTER_CLASS: "大师课程",
            EXPLORE_3D_WORLD: "探索 3D 领域",
            EXPLORE_2D_WORLD: "探索 2D 领域",
            EXPLORE_2D_3D_CONVERSION: "探索 2D/3D 之间的转换",
            META: {
                TITLE: "大师课程 - Reallusion 在线课程",
                DESCRIPTION: "向大师学习实践课程。",
                OG_TITLE: "大师课程 - Reallusion 在线课程",
                OG_DESCRIPTION: "向大师学习实践课程。",
            },
        },
        ONLINE_MANUAL: {
            NAME: "在线指南",
            TAB_3D_ANIMATION: "3D 动画",
            TAB_2D_ANIMATION: "2D 动画",
            TAB_OTHERS: "其他",
            OUTLINE_MANUAL: "在线指南",
            MAIN_PRODUCT: "主要产品",
            ICLONE_PLUG_IN: "iClone 外挂",
            CHARACTER_PLUG_IN: "Character Creator 外挂",
            CARTOON_ANIMATOR_PLUG_IN: "Cartoon Animator 外挂",
            LEARN: "学习中心",
            META: {
                TITLE: "在线指南 - Reallusion 在线课程",
                DESCRIPTION: "正在寻找详细使用说明？前往在线指南获得全面介绍。",
                OG_TITLE: "在线指南 - Reallusion 在线课程",
                OG_DESCRIPTION: "正在寻找详细使用说明？前往在线指南获得全面介绍。",
            },
        },
        SIDEBAR: {
            HOME: "首页",
            LIBRARY: "数据库",
            MASTER_CLASS: "大师课程",
            SKILL_PATH: "系列课程",
            WEBINAR: "网络研讨会 (英)",
            BOOKMARK: "书签",
            HISTORY: "观看纪录",
            ONLINE_MANUAL: "在线指南",
        },
        VIEW_MODE: {
            CARDS: "图标",
            DETAILS: "详细数据",
        },
        LOGIN: {
            PLEASE_LOG_IN: "请登录",
        },
        BOOKMARK: {
            META: {
                TITLE: "书签 - Reallusion 在线课程",
                DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 动画技能。立即透过免费教学视频和网络研讨会开始学习。",
                OG_TITLE: "书签 - Reallusion 在线课程",
                OG_DESCRIPTION: "在 iClone、Character Creator 和 Cartoon Animator 中提升您的 2D 和 3D 动画技能。立即透过免费教学视频和网络研讨会开始学习。",
            }
        },
        SKILL_PATH: {
            FILTER_TYPE: "所有类型",
            LEVEL: 'Skill Level',
            LENGTH: 'Length',
            SOFTWARE: 'Software',
            SKILL_REQUIREMENT: 'Skill Requirement',
            VIDEO_OUTLINE: 'Video Series Outline',
            VIDEO_LENGTH: {
                HOUR: 'hr',
                MINUTE: 'min',
                SECOND: 's'
            },
            NO_VIDEO: 'No Skill Path videos yet',
            VIEW_MORE: 'View more',
            VIEW_LESS: 'View less'
        }
    }
};

const datetimeFormats = {
    en: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric'
        }
    },
    de: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric'
        }
    },
    tw: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        }
    },
    cn: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        }
    },
    jp: {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        }
    }
}

const numberFormats = {
    en: {
        currency: {
            style: 'currency', currency: 'USD', notation: 'standard'
        },
    },
    de: {
        currency: {
            style: 'currency', currency: 'USD', notation: 'standard'
        },
    },
    jp: {
        currency: {
            style: 'currency', currency: 'JPY', useGrouping: true, currencyDisplay: 'symbol'
        },
    },
    tw: {
        currency: {
            style: 'currency', currency: 'NTD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 0
        },
    },
    cn: {
        currency: {
            style: 'currency', currency: 'CNY', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 0
        },
    }
}

const mergeData = (messages, objectData) => {
    const mergedData = {};
    const keys = Object.keys(messages);
    
    for (const key of keys) {
        mergedData[key] = { ...messages[key], ...objectData[key] };
    }

    return mergedData;
}

export default createI18n({
    locale: languageEnum.EN, // 設定語言
    fallbackLocale: languageEnum.EN, // 若選擇的語言缺少翻譯則退回的語言
    messages: mergeData(messages, objectData),
    datetimeFormats,
    numberFormats
});
